import React, { useState } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function AddShippingCharge() {
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    Pincode: "",
    Shipping_Amount: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (name === "Pincode" && !/^\d*$/.test(value)) return;  Allow only numbers for Pincode
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    // if (!/^\d{8}$/.test(formData.Pincode)) {
    //   toast.error("Pincode must be a 8-digit number.");
    //   return false;
    // }

    if (parseFloat(formData.Shipping_Amount) <= 0) {
      toast.error("Shipping amount must be greater than 0.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/addshipping`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok) {
        toast.success("Shipping charge added successfully!");
        setFormData({ Pincode: "", Shipping_Amount: "" });
      } else {
        toast.error(data.message || "Failed to add Shipping Charge");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Shipping Charge</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Add Shipping Charge</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <form className="row g-3 pt-4" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="pin_code"
                    placeholder="Enter Pin Code"
                    name="Pincode"
                    value={formData.Pincode}
                    onChange={handleChange}
                    maxLength="8"
                    required
                  />
                  <label htmlFor="pin_code">Postal Code</label>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    id="Shipping_Amount"
                    placeholder="Enter Shipping Amount"
                    name="Shipping_Amount"
                    value={formData.Shipping_Amount}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="Shipping_Amount">Shipping Amount</label>
                </div>
              </div>
              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Shipping Charge"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default AddShippingCharge;
